import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4 8L7 11L13 5" stroke="#DF692B" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#DF692B" />
    </Svg>
  );
};

export default Icon;
